import { ScheduleMessageType } from "../models/conversations/schedule-messages.model";
import { UtilityService } from "../services/UtilityService";

export const buildCronExpression = (type: ScheduleMessageType, ScheduledateTime: number) => {

    let dateTime = UtilityService.convertToPreferredTimeZone(ScheduledateTime);

    let secondsField = `0`;
    let minutesField = `${dateTime.getUTCMinutes()}`;
    let hoursField = `${dateTime.getUTCHours()}`;
    let monthDayField = `${dateTime.getUTCDate()}`;
    let monthField = `${dateTime.getUTCMonth() + 1}`;
    let weekDayField = `${dateTime.getUTCDay() + 1}`;
    let yearField = `*`;

    switch (type) {
        case ScheduleMessageType.ONE_TIME:
            weekDayField = `?`;
            break;
        case ScheduleMessageType.DAILY:
            monthDayField = `1/1`;
            monthField = `*`;
            weekDayField = `?`;
            break;
        case ScheduleMessageType.WEEKLY:
        case ScheduleMessageType.EVERY_2_WEEKS:
            monthDayField = `?`;
            monthField = `*`;
            break;
        case ScheduleMessageType.MONTHLY:
            monthField = `1/1`;
            weekDayField = `?`;
            break;
        case ScheduleMessageType.EVERY_YEAR: {
            return `${secondsField} ${minutesField} ${hoursField} ${monthDayField} ${monthField} ? *`;
        }

        case ScheduleMessageType.EVERY_6_MONTHS:
            const currentMonth = dateTime.getMonth() + 1;
            const nextMonth = ((currentMonth + 6 - 1) % 12) + 1;
            monthDayField = dateTime.getDate().toString();
            monthField = `${currentMonth},${nextMonth}`;
            weekDayField = "?";
            break;
    }
    return `${secondsField} ${minutesField} ${hoursField} ${monthDayField} ${monthField} ${weekDayField} ${yearField}`;
}